import UserDeleteModal from './UserDeleteModal';

export default UserDeleteModal;
